var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"tips"}),_c('div',[_c('img',{staticStyle:{"width":"230px"},attrs:{"src":require("@/assets/weixin.png")}})])])
}]

export { render, staticRenderFns }